export default __webpack_public_path__ + "static/3bc5a2acbbfcc387398eeb59fc7ab4b5.jpg";